export default __webpack_public_path__ + "static/media/J_wdt_c_cap_1.1c20b4af.mp3";